import ajaxService from './ajaxService';

export default {
  // 取得會員資料
  putEdenredSendTime(body, headers) {
    return ajaxService.post('/pmt/put/api/v1/edenred', body, headers);
  },
};
